
import React from 'react';
import SidebarFrame from "./SidebarFrame";
import Dialogs from "oc-ui/dialogs/Dialogs";


export default class ProductDragSettings extends SidebarFrame {

    renderTitle() {
        return this.props.title;
    }

    draggable(element, product) {
        APP.interactionHandler.draggable(element)
            .setDragObject3D((handle) => APP.model.createDragObject(product));
    }

    bild(product) {
        const bild = product.Bild || "default.png";
        return SETTINGS.wkfgContentBaseUrl + bild;
    }

    renderBody() {
        return (
            <div>
                <fieldset>
                    {this.props.products.map((product, index) =>
                        <div key={index} className="productdrag image-text stop-select"  ref={e => this.draggable(e, product)} onClick={this.onClick}>
                            <div className="image no-pointer" style={{backgroundImage:'url('+this.bild(product)+')'}}></div>
                            <div className="text">{product.TypAnzeigename}</div>
                            <div className="info" onClick={()=>APP.uiHandler.showHelpPopup(product)}></div>
                        </div>
                    )}
                </fieldset>
            </div>
        )
    }
}